<script>
/* eslint-env browser */
import { useAccount } from 'dashboard/composables/useAccount';
import { useBranding } from 'shared/composables/useBranding';
import { mapGetters } from 'vuex';

export default {
  setup() {
    const { accountId } = useAccount();
    const { replaceInstallationName } = useBranding();
    return {
      accountId,
      replaceInstallationName,
    };
  },

  data() {
    return {
      errorStateMessage: this.$route.query.error,
    };
  },

  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
    }),
  },

  methods: {
    async lazadaAuthorize() {
      let redirectUri = `${window.location.origin}/lazada/callback?account_id=${this.accountId}`;
      const appKey = window.chatwootConfig.lazadaAppKey;
      const authUri = `https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=${redirectUri}&client_id=${appKey}`;
      window.location.href = authUri;
    },
  },
};
</script>

<template>
  <div
    class="border border-n-weak bg-n-solid-1 rounded-t-lg border-b-0 h-full w-full p-6 col-span-6 overflow-auto"
  >
    <div class="flex flex-col items-center justify-center h-full text-center">
      <p class="text-danger mb-5 text-red-400">
        {{ errorStateMessage }}
      </p>
      <a
        href="#"
        class="button icon-button rounded-md flex justify-center items-center gap-2 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 border border-solid border-slate-200 dark:border-slate-700 hover:border-woot-500 dark:hover:border-woot-500 transition-all duration-200 ease-in px-4 py-2"
        @click="lazadaAuthorize()"
      >
        <img
          width="48"
          src="~dashboard/assets/images/channels/lazada.png"
          alt="Lazada-logo"
        />
        <span>{{ $t('INBOX_MGMT.ADD.LAZADA.CONNECT') }}</span>
      </a>
      <p class="py-6">
        {{
          replaceInstallationName(
            $t('INBOX_MGMT.ADD.LAZADA.HELP'),
            globalConfig.installationName
          )
        }}
      </p>
    </div>
  </div>
</template>
